
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarRangeIec as ObiRadarRangeIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-range-iec.js';
 
 
 

 
 export const ObiRadarRangeIec = createComponent({
   react: React,
   tagName: 'obi-radar-range-iec',
   elementClass: ObiRadarRangeIecElement,
   events: {
     
   }
  });
 
 